// 8 основних правил граматики (частина 1) lesson 29
// 8 основних правил граматики (частина 2) lesson 30
// Непряма мова lesson 23
// Підрядні речення 22
// Майбутній тривалий 9
// Минулий тривалий 10
//lesson 13 Теперішній доконаний тривалий час


const sentences = [

  //lesson 1 Вимова. Правила читання
  { beginning: "", word: "date", translat: "[deit]", ending: "" },
  { beginning: "", word: "man", translat: "[mæn]", ending: "" },
  { beginning: "", word: "home", translat: "[houm]", ending: "" },
  { beginning: "", word: "shop", translat: "[ʃop]", ending: "" },
  { beginning: "", word: "he", translat: "[hі:]", ending: "" },
  { beginning: "", word: "pencil", translat: "[pensl]", ending: "" },
  { beginning: "", word: "student", translat: "[stjudənt]", ending: "" },
  { beginning: "", word: "cup", translat: "[kʌp]", ending: "" },
  { beginning: "", word: "time", translat: "[taim]", ending: "" },
  { beginning: "", word: "cry", translat: "[krai]", ending: "" },
  //lesson 2 Pronouns. To Be
  { beginning: "", word: "Я", translat: "I", ending: "love Ukraine" },
  { beginning: "", word: "Він", translat: "He", ending: "likes ice-cream" },
  { beginning: "", word: "Ми", translat: "We", ending: "learn English" },
  { beginning: "", word: "Вона", translat: "She", ending: "goes to town" },
  { beginning: "", word: "Ти", translat: "You", ending: "help people" },
  { beginning: "", word: "Вони", translat: "They", ending: "look in the window" },
  { beginning: "", word: "Ви", translat: "You", ending: "will find the key" },
  { beginning: "", word: "Воно", translat: "It", ending: "knows something" },
  { beginning: "", word: "Ми", translat: "We", ending: "want peace" },
  { beginning: "", word: "Вони", translat: "They", ending: "take our time" },
  //lesson 3 Теперішній простий час
  { beginning: "I", word: "хочу", translat: "want", ending: "more juice" },
  { beginning: "She", word: "має", translat: "has", ending: "many friends" },
  { beginning: "What do you", word: "їсте", translat: "eat", ending: "?" },
  { beginning: "We", word: "говоримо", translat: "talk", ending: "about school" },
  { beginning: "All kids", word: "граються", translat: "play", ending: "" },
  { beginning: "He", word: "бігає", translat: "runs", ending: "fast" },
  { beginning: "Many birds", word: "співають", translat: "sing", ending: "" },
  { beginning: "They", word: "роблять", translat: "do", ending: "homework" },
  { beginning: "Most people", word: "посміхаються", translat: "smile", ending: "" },
  { beginning: "Time", word: "йде", translat: "goes", ending: "fast" },
  //lesson 4 Майбутній простий час
  { beginning: "I", word: "прочитаю", translat: "will read", ending: "this book" },
  { beginning: "She", word: "використає", translat: "will use", ending: "that pan" },
  { beginning: "They", word: "зроблять", translat: "will make", ending: "a cake" },
  { beginning: "He", word: "залишиться", translat: "will stay", ending: "because he cares" },
  { beginning: "It", word: "буде", translat: "will be", ending: "such a fun day" },
  { beginning: "We", word: "пройдемо", translat: "will go", ending: "through the tunnel" },
  { beginning: "You", word: "отримаєш", translat: "will get", ending: "a gift" },
  { beginning: "I", word: "працюватиму", translat: "will work", ending: "tomorrow" },
  { beginning: "They", word: "допоможуть", translat: "will help", ending: "us" },
  { beginning: "This", word: "буде", translat: "will be", ending: "a different story" },
  //lesson 5 Минулий простий час
  { beginning: "I", word: "потребував", translat: "needed", ending: "help" },
  { beginning: "They", word: "дивилися", translat: "watched", ending: "a new film" },
  { beginning: "She just", word: "прибув", translat: "arrived", ending: "" },
  { beginning: "He only", word: "посміхнувся", translat: "smiled", ending: "" },
  { beginning: "We", word: "користувалися", translat: "used", ending: "the old book" },
  { beginning: "It", word: "виглядало", translat: "looked", ending: "good" },
  { beginning: "She", word: "поливала", translat: "watered", ending: "the plants" },
  { beginning: "They", word: "вивчали", translat: "studied", ending: "history" },
  { beginning: "He", word: "хотів", translat: "wanted", ending: "some water" },
  { beginning: "I", word: "дзвонив", translat: "called", ending: ", but no one answered" },

  //lesson 6 Неправильні дієслова
  { beginning: "I", word: "дивився", translat: "saw", ending: "a new film" },
  { beginning: "She just", word: "пішла", translat: "went", ending: "home" },
  { beginning: "He only", word: "дала", translat: "gave", ending: "one answer" },
  { beginning: "We", word: "випили", translat: "drank", ending: "water" },
  { beginning: "They", word: "були", translat: "were", ending: "very happy" },
  { beginning: "I", word: "мали", translat: "had", ending: "a good time" },
  { beginning: "He", word: "прийшов", translat: "came", ending: "early" },
  { beginning: "She", word: "взяла", translat: "took", ending: "some bread" },
  { beginning: "I", word: "думав", translat: "thought", ending: "about that" },
  { beginning: "They", word: "склали", translat: "made", ending: "a plan" },

  //lesson 7 Прості часи: підсумок
  { beginning: "I", word: "знаю", translat: "know", ending: "the way" },
  { beginning: "She", word: "почуватиметься", translat: "will feel", ending: "well" },
  { beginning: "He", word: "пішов", translat: "went", ending: "first" },
  { beginning: "My friend", word: "може", translat: "can", ending: "draw" },
  { beginning: "You", word: "знатимеш", translat: "will know", ending: "his name" },
  { beginning: "I", word: "сказав", translat: "said", ending: "yes" },
  { beginning: "He", word: "буде мати", translat: "will have", ending: "money" },
  { beginning: "Then we", word: "пішли", translat: "walked", ending: "home" },
  { beginning: "Each child", word: "може", translat: "can", ending: "read" },
  { beginning: "They", word: "любили", translat: "loved", ending: "art" },

  //lesson 8 Теперішній тривалий час
  { beginning: "She", word: "дивиться", translat: "is looking", ending: "at the wall" },
  { beginning: "People", word: "подорожують", translat: "are travelling", ending: "around the world" },
  { beginning: "He", word: "читає", translat: "is reading", ending: "a newspaper" },
  { beginning: "We", word: "вивчають", translat: "are studing", ending: "the map now" },
  { beginning: "They", word: "намагаються", translat: "are trying", ending: "to find the answer" },
  { beginning: "I", word: "не їм", translat: "am not eating", ending: "much today" },
  { beginning: "She", word: "знімає", translat: "is taking", ending: "a photo" },
  { beginning: "He", word: "каже", translat: "is saying", ending: "he wants more food" },
  { beginning: "We", word: "говоримо", translat: "are talking", ending: "about something important" },
  { beginning: "My family", word: "обідає", translat: "is having", ending: "dinner" },
  // lesson 9 Майбутній тривалий
  { beginning: "She", word: "буде дивитися", translat: "will be looking", ending: "at the wall" },
  { beginning: "People", word: "будуть подорожувати", translat: "will be travelling", ending: "around the world" },
  { beginning: "He", word: "буде читати", translat: "will be reading", ending: "a newspaper" },
  { beginning: "We", word: "будемо вивчати", translat: "will be studying", ending: "the map" },
  { beginning: "They", word: "будуть намагатися", translat: "will be trying", ending: "to find the answer" },
  { beginning: "I", word: "не буду їсти", translat: "will not be eating", ending: "much" },
  { beginning: "She", word: "буде знімати", translat: "will be taking", ending: "a photo" },
  { beginning: "He", word: "буде казати", translat: "will be saying", ending: "he wants more food" },
  { beginning: "We", word: "будемо говорити", translat: "will be talking", ending: "about something important" },
  { beginning: "My family", word: "буде обідати", translat: "will be having", ending: "dinner" },

  // lesson 10 Минулий тривалий
  { beginning: "She", word: "дивилася", translat: "was looking", ending: "at the wall" },
  { beginning: "People", word: "подорожували", translat: "were travelling", ending: "around the world" },
  { beginning: "He", word: "читав", translat: "was reading", ending: "a newspaper" },
  { beginning: "We", word: "вивчали", translat: "were studying", ending: "the map" },
  { beginning: "They", word: "намагалися", translat: "were trying", ending: "to find the answer" },
  { beginning: "I", word: "не їв", translat: "was not eating", ending: "much" },
  { beginning: "She", word: "знімала", translat: "was taking", ending: "a photo" },
  { beginning: "He", word: "казав", translat: "was saying", ending: "he wanted more food" },
  { beginning: "We", word: "говорили", translat: "were talking", ending: "about something important" },
  { beginning: "My family", word: "обідала", translat: "was having", ending: "dinner" },

  //lesson 11  Тривалі часи: підсумок
  { beginning: "She", word: "читає", translat: "is reading", ending: "a new book" },
  { beginning: "They", word: "не тримали", translat: "were not keeping", ending: "the door open" },
  { beginning: "We", word: "приєднаємося", translat: "will be joining", ending: "this project" },
  { beginning: "He", word: "починає", translat: "is starting", ending: "a new job" },
  { beginning: "I", word: "вивчав", translat: "was learning", ending: "a lot last year" },
  { beginning: "The teacher", word: "допомагатиме", translat: "will be helping", ending: "every student" },
  { beginning: "They", word: "працюють", translat: "are working", ending: "in the field now" },
  { beginning: "We", word: "будемо будувати", translat: "will be building", ending: "a large house" },
  { beginning: "She", word: "кликала", translat: "was calling", ending: "us" },
  { beginning: "He", word: "робив", translat: "was making", ending: "the files available" },
  //lesson 12 Теперішній доконаний час
  { beginning: "She", word: "прочитала", translat: "has read", ending: "the book" },
  { beginning: "We", word: "прибрали", translat: "have cleaned", ending: "the room" },
  { beginning: "They", word: "віддали", translat: "have given", ending: "us the keys" },
  { beginning: "He", word: "приготував", translat: "has cooked", ending: "dinner" },
  { beginning: "Both teams", word: "відіграли", translat: "have played", ending: "well" },
  { beginning: "She", word: "шукала", translat: "has searched", ending: "for her phone everywhere" },
  { beginning: "You", word: "написав", translat: "have written", ending: "a letter" },
  { beginning: "She", word: "знайшла", translat: "has found", ending: "something interesting" },
  { beginning: "They", word: "прийшли", translat: "have come", ending: "to visit us" },
  { beginning: "We", word: "зустріли", translat: "have met", ending: "the local guide" },
  //lesson 13 Теперішній доконаний тривалий час   
  { beginning: "She", word: "читає", translat: "has been reading", ending: "that book since last week" },
  { beginning: "We", word: "прибираємо", translat: "have been cleaning", ending: "the room for two hours" },
  { beginning: "They", word: "віддають", translat: "have been giving", ending: "us the keys since this morning" },
  { beginning: "He", word: "готує", translat: "has been cooking", ending: "dinner for an hour" },
  { beginning: "Both teams", word: "грають", translat: "have been playing", ending: "well since the match started" },
  { beginning: "She", word: "шукає", translat: "has been searching", ending: "for her phone everywhere since yesterday" },
  { beginning: "You", word: "пишеш", translat: "have been writing", ending: "a letter for half an hour" },
  { beginning: "She", word: "шукає", translat: "has been looking", ending: "for something interesting all day" },
  { beginning: "They", word: "приходять", translat: "have been coming", ending: "to visit us since January" },
  { beginning: "We", word: "розмовляємо", translat: "have been talking", ending: "to the local guide for the last 15 minutes" },
  //lesson 14 Порівняння всіх часів 
  { beginning: "He", word: "буде", translat: "will be", ending: "a great player" },
  { beginning: "We", word: "використали", translat: "used", ending: "a wide range of tools" },
  { beginning: "She", word: "підвищить", translat: "will increase", ending: "the interest rate tomorrow" },
  { beginning: "They", word: "зрозуміли", translat: "understood", ending: "the real reason behind it" },
  { beginning: "I", word: "подорожуватиму", translat: "will travel", ending: "to Italy in August" },
  { beginning: "You", word: "побачив", translat: "saw", ending: "a variety of animals at the zoo" },
  { beginning: "We", word: "переглянемо", translat: "will watch", ending: "the video after lunch" },
  { beginning: "She", word: "провела", translat: "spent", ending: "a week by the sea" },
  { beginning: "I", word: "буду", translat: "will be", ending: "above the required level" },
  { beginning: "They", word: "діяли", translat: "acted", ending: "according to the plan" },

  //lesson 15 Прийменники місця
  { beginning: "The book is", word: "на", translat: "on", ending: "the table" },
  { beginning: "The cat is", word: "під", translat: "under", ending: "the chair" },
  { beginning: "The keys are", word: "в", translat: "in", ending: "my bag" },
  { beginning: "The clock is", word: "над", translat: "above", ending: "the door" },
  { beginning: "The shoes are", word: "біля", translat: "next to", ending: "the bed" },
  { beginning: "The ball is", word: "за", translat: "behind", ending: "the sofa" },
  { beginning: "The school is", word: "поруч з", translat: "near", ending: "the park" },
  { beginning: "The lamp is", word: "між", translat: "between", ending: "the two windows" },
  { beginning: "The picture is", word: "на", translat: "on", ending: "the wall" },
  { beginning: "The bag is", word: "перед", translat: "in front of", ending: "the door" },

  //lesson 16 Час і дата
  { beginning: "The meeting is", word: "о", translat: "at", ending: "3 PM" },
  { beginning: "The party is", word: "в", translat: "at", ending: "midnight" },
  { beginning: "The exam is", word: "в", translat: "on", ending: "Monday" },
  { beginning: "Her birthday is", word: "в", translat: "on", ending: "March 10th" },
  { beginning: "We have a holiday", word: "в", translat: "in", ending: "December" },
  { beginning: "I was born", word: "в", translat: "in", ending: "1998" },
  { beginning: "The show starts", word: "о", translat: "at", ending: "noon" },
  { beginning: "We will meet", word: "в", translat: "on", ending: "Friday evening" },
  { beginning: "The flowers bloom", word: "в", translat: "in", ending: "spring" },
  { beginning: "I usually wake up", word: "о", translat: "at", ending: "7 AM" },

  //lesson 17 Артиклі. Конструкція There is/There are
  { beginning: "", word: "Є", translat: "There is", ending: "a book on the table" },
  { beginning: "", word: "Був", translat: "There was", ending: "a cat in the box" },
  { beginning: "", word: "Буде", translat: "There will be", ending: "a letter for you" },
  { beginning: "", word: "Є", translat: "There is", ending: "a problem with the plan" },
  { beginning: "", word: "Була", translat: "There was", ending: "a cup on the shelf" },
  { beginning: "", word: "Є", translat: "There are", ending: "three apples in the bowl" },
  { beginning: "", word: "Були", translat: "There were", ending: "many students in the class" },
  { beginning: "", word: "Будуть", translat: "There will be", ending: "new messages in your inbox" },
  { beginning: "", word: "Є", translat: "There are", ending: "two windows in the room" },
  { beginning: "", word: "Були", translat: "There were", ending: "books on the desk" },

  //lesson 18 Однина і множина. Ступені порівняння. Порядкові й кількісні числівники
  { beginning: "This task is", word: "легший", translat: "easier", ending: "than the previous one" },
  { beginning: "He is", word: "вищий", translat: "taller", ending: "than his brother" },
  { beginning: "Today is", word: "холодніший", translat: "colder", ending: "than yesterday" },
  { beginning: "She is", word: "найрозумніша", translat: "the smartest", ending: "student in the class" },
  { beginning: "This book is", word: "цікавіша", translat: "more interesting", ending: "than that one" },
  { beginning: "Mount Everest is", word: "найвища", translat: "the highest", ending: "mountain in the world" },
  { beginning: "This road is", word: "ширша", translat: "wider", ending: "than the other one" },
  { beginning: "He ran", word: "швидше", translat: "faster", ending: "than anyone else" },
  { beginning: "It was", word: "найгірший", translat: "the worst", ending: "day of my life" },
  { beginning: "This solution is", word: "краща", translat: "better", ending: "than the first one" },

  //lesson 19 Активний і пасивний стан
  { beginning: "The cake", word: "був спечений", translat: "was baked", ending: "by my mom" },
  { beginning: "The house", word: "був побудований", translat: "was built", ending: "in 1995" },
  { beginning: "The letters", word: "були надіслані", translat: "were sent", ending: "yesterday" },
  { beginning: "The documents", word: "були підписані", translat: "were signed", ending: "by the manager" },
  { beginning: "The window", word: "було розбите", translat: "was broken", ending: "during the storm" },
  { beginning: "The project", word: "був завершений", translat: "was completed", ending: "on time" },
  { beginning: "The homework", word: "була зроблена", translat: "was done", ending: "by the student" },
  { beginning: "The room", word: "була прибрана", translat: "was cleaned", ending: "this morning" },
  { beginning: "The email", word: "був надісланий", translat: "was sent", ending: "to the client" },
  { beginning: "The pictures", word: "були зроблені", translat: "were taken", ending: "during the trip" },

  //lesson 20 Модальні дієслова, конструкції Would і Used to
  { beginning: "You", word: "можеш", translat: "can", ending: "finish this task later" },
  { beginning: "She", word: "повинна", translat: "must", ending: "wear a uniform at school" },
  { beginning: "We", word: "маємо", translat: "have to", ending: "leave early today" },
  { beginning: "He", word: "міг би", translat: "could", ending: "help you with that" },
  { beginning: "They", word: "мають", translat: "have to", ending: "follow the rules" },
  { beginning: "I", word: "змушений був", translat: "had to", ending: "cancel the meeting" },
  { beginning: "She", word: "мала б", translat: "should have", ending: "called you yesterday" },
  { beginning: "You", word: "слід", translat: "should", ending: "drink more water" },
  { beginning: "He", word: "може", translat: "may", ending: "arrive later" },
  { beginning: "We", word: "могли б", translat: "might", ending: "go hiking this weekend" },

  //lesson 21 Наказові речення
  { beginning: "", word: "Зроби", translat: "Do", ending: "your homework" },
  { beginning: "", word: "Слухай", translat: "Listen", ending: "carefully" },
  { beginning: "", word: "Приходь", translat: "Come", ending: "here" },
  { beginning: "", word: "Відкрий", translat: "Open", ending: "the window" },
  { beginning: "", word: "Пиши", translat: "Write", ending: "your name" },
  { beginning: "", word: "Подивися", translat: "Look", ending: "at the board" },
  { beginning: "", word: "Чекай", translat: "Wait", ending: "for me" },
  { beginning: "", word: "Говори", translat: "Speak", ending: "more slowly" },
  { beginning: "", word: "Закрий", translat: "Close", ending: "the door" },
  { beginning: "", word: "Допоможи", translat: "Help", ending: "your friend" },
  // lesson 22 Підрядні речення
  { beginning: "The man", word: "який", translat: "who", ending: "lives next door is friendly" },
  { beginning: "The car", word: "яку", translat: "which", ending: "she drives is new" },
  { beginning: "The girl", word: "яка", translat: "who", ending: "is talking to Tom is my sister" },
  { beginning: "The house", word: "який", translat: "which", ending: "we bought needs repairs" },
  { beginning: "The dog", word: "який", translat: "that", ending: "barks every night is ours" },
  { beginning: "The teacher", word: "який", translat: "who", ending: "teaches math is very kind" },
  { beginning: "The movie", word: "який", translat: "which", ending: "we watched was funny" },
  { beginning: "The phone", word: "який", translat: "that", ending: "I lost has been found" },
  { beginning: "The friend", word: "який", translat: "who", ending: "helped me is very smart" },
  { beginning: "The song", word: "яку", translat: "which", ending: "she sings is beautiful" },

  // lesson 23 Непряма мова
  { beginning: "He said that he", word: "працює", translat: "was working", ending: "at the office" },
  { beginning: "They said that they", word: "дивляться", translat: "were watching", ending: "the new film" },
  { beginning: "I said that I", word: "йду", translat: "was going", ending: "home" },
  { beginning: "We said that we", word: "допомагаємо", translat: "were helping", ending: "our friends" },
  { beginning: "She said that she", word: "закінчує", translat: "was finishing", ending: "her homework" },
  { beginning: "He said that he", word: "читає", translat: "was reading", ending: "a book" },
  { beginning: "They said that they", word: "подорожують", translat: "were travelling", ending: "to London" },
  { beginning: "I said that I", word: "знаю", translat: "knew", ending: "the answer" },
  { beginning: "We said that we", word: "готуємо", translat: "were cooking", ending: "dinner" },
  { beginning: "She said that she", word: "розмовляє", translat: "was talking", ending: "to him" },

    //lesson 24 Прості часи: повторення
    { beginning: "I", word: "піду", translat: "will go", ending: "to the gym tomorrow" },
  { beginning: "I", word: "пішов", translat: "went", ending: "to the gym yesterday" },
  { beginning: "She", word: "приготує", translat: "will cook", ending: "dinner tonight" },
  { beginning: "She", word: "приготувала", translat: "cooked", ending: "dinner last night" },
  { beginning: "We", word: "зустрінемося", translat: "will meet", ending: "at 6 PM" },
  { beginning: "We", word: "зустрілися", translat: "met", ending: "at 6 PM yesterday" },
  { beginning: "They", word: "поїдуть", translat: "will travel", ending: "to France next year" },
  { beginning: "They", word: "поїхали", translat: "traveled", ending: "to France last year" },
  { beginning: "He", word: "побачить", translat: "will see", ending: "the doctor tomorrow" },
  { beginning: "He", word: "побачив", translat: "saw", ending: "the doctor yesterday" },

  //lesson 25 Тривалі часи: повторення
  { beginning: "I", word: "буду працювати", translat: "will be working", ending: "at 5 PM tomorrow" },
  { beginning: "I", word: "працював", translat: "was working", ending: "at 5 PM yesterday" },
  { beginning: "She", word: "буде читати", translat: "will be reading", ending: "a book in the evening" },
  { beginning: "She", word: "читала", translat: "was reading", ending: "a book last night" },
  { beginning: "They", word: "будуть грати", translat: "will be playing", ending: "football in the afternoon" },
  { beginning: "They", word: "грали", translat: "were playing", ending: "football yesterday afternoon" },
  { beginning: "We", word: "будемо дивитися", translat: "will be watching", ending: "a movie at 8" },
  { beginning: "We", word: "дивилися", translat: "were watching", ending: "a movie at 8 last night" },
  { beginning: "He", word: "буде писати", translat: "will be writing", ending: "an email in the morning" },
  { beginning: "He", word: "писав", translat: "was writing", ending: "an email when I called" },

  //lesson 26 Теперішній доконаний і Теперішній доконаний тривалий: повторення - доробити
  { beginning: "I", word: "зробив", translat: "have done", ending: "my homework" },
  { beginning: "She", word: "прочитала", translat: "has read", ending: "the book" },
  { beginning: "They", word: "відвідали", translat: "have visited", ending: "Paris twice" },
  { beginning: "We", word: "бачили", translat: "have seen", ending: "that movie already" },
  { beginning: "He", word: "втратив", translat: "has lost", ending: "his keys" },
  { beginning: "I", word: "написав", translat: "have written", ending: "three emails today" },
  { beginning: "She", word: "прибрала", translat: "has cleaned", ending: "her room" },
  { beginning: "We", word: "закінчили", translat: "have finished", ending: "the project" },
  { beginning: "They", word: "прийшли", translat: "have come", ending: "back from vacation" },
  { beginning: "He", word: "поїв", translat: "has eaten", ending: "already" },

  //lesson 27 Повторення всіх часів - перевірити
  { beginning: "Tom", word: "не пішов", translat: "did not go", ending: "to school yesterday" },
  { beginning: "", word: "Він пішов", translat: "Did he go", ending: "to school yesterday?" },
  { beginning: "They", word: "не грали", translat: "did not play", ending: "football on Sunday" },
  { beginning: "", word: "Вони грали", translat: "Did they play", ending: "football on Sunday?" },
  { beginning: "She", word: "не бачила", translat: "did not see", ending: "the movie" },
  { beginning: "", word: "бачила", translat: "Did she see", ending: "the movie?" },
  { beginning: "We", word: "не приготували", translat: "did not cook", ending: "dinner" },
  { beginning: "", word: "приготували", translat: "Did we cook", ending: "dinner?" },
  { beginning: "I", word: "не написав", translat: "did not write", ending: "the letter" },
  { beginning: "", word: "написав", translat: "Did I write", ending: "the letter?" },

  //lesson 28 Рідковживані часи
  { beginning: "I", word: "закінчу", translat: "will have finished", ending: "my homework by 8 PM" },
  { beginning: "She", word: "вже поїхала", translat: "had already left", ending: "when I arrived" },
  { beginning: "They", word: "зроблять", translat: "will have done", ending: "the work by tomorrow" },
  { beginning: "We", word: "закінчили", translat: "had finished", ending: "dinner before the guests came" },
  { beginning: "He", word: "прочитає", translat: "will have read", ending: "the book by next week" },
  { beginning: "I", word: "вже зробив", translat: "had already done", ending: "my chores before noon" },
  { beginning: "You", word: "закінчиш", translat: "will have completed", ending: "the project by Friday" },
  { beginning: "They", word: "завершили", translat: "had completed", ending: "the task earlier" },
  { beginning: "We", word: "побачимо", translat: "will have seen", ending: "the movie by Sunday" },
  { beginning: "He", word: "вже пішов", translat: "had already gone", ending: "when we called" },

  //lesson 29 8 rules
  { beginning: "Tom watched the movie where the hero", word: "jumps", translat: "jumped", ending: "from the cliff" },
  { beginning: "Rachel read the story where the princess", word: "meets", translat: "met", ending: "a dragon" },
  { beginning: "Liam and Emma saw the game where the player", word: "scores", translat: "scored", ending: "the winning goal" },
  { beginning: "Olivia told Mark about a man who", word: "lives", translat: "lived", ending: "in the forest" },
  { beginning: "Ethan liked the book where the detective", word: "solves", translat: "solved", ending: "the mystery" },
  { beginning: "Sophie visited the museum where the artist", word: "paints", translat: "painted", ending: "famous landscapes" },
  { beginning: "Noah heard the story where the boy", word: "finds", translat: "found", ending: "a treasure" },
  { beginning: "Isabella watched the show where the singer", word: "sings", translat: "sang", ending: "a beautiful song" },
  { beginning: "Lily remembered the day when the sun", word: "shines", translat: "shone", ending: "so brightly" },
  { beginning: "Jack and Mia read the article where the scientist", word: "discovers", translat: "discovered", ending: "a new planet" },

  //lesson 30 8 rules
  { beginning: "She", word: "play", translat: "plays", ending: "the piano" },
  { beginning: "Tom", word: "read", translat: "reads", ending: "a newspaper in the morning" },
  { beginning: "I", word: "drive", translat: "drive", ending: "to work" },
  { beginning: "The dog", word: "like", translat: "likes", ending: "bones" },
  { beginning: "He", word: "watch", translat: "watches", ending: "TV in the evening" },
  { beginning: "Sarah", word: "teach", translat: "teaches", ending: "English" },
  { beginning: "The train", word: "leave", translat: "leaves", ending: "at 7 a.m." },
  { beginning: "They", word: "go", translat: "go", ending: "to school by bus" },
  { beginning: "It", word: "rain", translat: "rains", ending: "a lot in autumn" },
  { beginning: "John", word: "miss", translat: "misses", ending: "his family" }
]

const instructions = [
  "Прочитайте слова",
  "Замініть на правильні займенники",
  "Перекладіть дієслово в простому теперішньому часі",
  "Перекладіть в майбутньому простому часі",
  "Перекладіть в простому минулому часі",
  "Перекладіть неправильне дієслово в минулому часі",
  "Перекладіть слова в правильному часі",
  "Зробіть переклад в теперішньому тривалому часі",
  "Зробіть переклад в майбутньому тривалому часі",
  "Зробіть переклад в минулому тривалому часі",
  "Який тривалий час потрбіно застосувати: теперішній, минулий, чи майбутній?",
  "Перекладіть у теперішньому доконаному часі",
  "Перекладіть у теперішньому доконаному тривалому часі",
  "Перекладіть у правильному простому часі",
  "Зробіть правильний переклад прийменника",
  "Перекладіть слово",
  "Зробіть переклад",
  "Перекладіть прикметник",
  "Перекладіть у пасивному стані",
  "Перекладіть дієслова, користуючись табличкою",
  "Перекладіть слова",
  "Замініть на правильний відносний займенник",
  "Замініть на правильне слово - дія відбувалася під час розмови",
  "Замініть на слово в правильному часі",
  "Замініть на конструкцію в правильному тривалому часі",
  "Замініть на конструкцію в теперішньому доконаному часі",
  "Замініть на конструкцію в простому минулому часі",
  "Замініть на конструкцію у минулому або майбутньому доконаному часі",
  "Замініть виділене слово на дієслово в правильному часі",
  "Виправте виділені слова"
];



export const ReplaceitExerciseData = sentences.map((value, index) => (
  {
    id: index + 1,
    lesson: Math.floor(index / 10) + 1,
    display_word: "block",
    display_translat: "none",
    instruction: instructions[Math.floor(index / 10)],
    sentence: {
      beginning: value.beginning,
      word: value.word,
      translat: value.translat,
      ending: value.ending
    }
  }
))




/*

    //lesson 27 Повторення всіх часів
    { beginning: "I", word: "побачив", translat: "saw", ending: "a shooting star last night" },
    { beginning: "She", word: "написала", translat: "wrote", ending: "a poem for the contest" },
    { beginning: "They", word: "пішли", translat: "went", ending: "to the new museum" },
    { beginning: "He", word: "випив", translat: "drank", ending: "all the juice" },
    { beginning: "We", word: "купили", translat: "bought", ending: "some fruit at the market" },
    { beginning: "You", word: "зламав", translat: "broke", ending: "your phone again" },
    { beginning: "I", word: "взяв", translat: "took", ending: "the wrong bus" },
    { beginning: "She", word: "зробила", translat: "made", ending: "a delicious cake" },
    { beginning: "They", word: "забули", translat: "forgot", ending: "his birthday" },
    { beginning: "He", word: "приніс", translat: "brought", ending: "his guitar to the party" },

    //lesson  Час і дата
    { beginning: "The train arrives", word: "о", translat: "at", ending: "7 o'clock" },
    { beginning: "The party is", word: "в", translat: "on", ending: "Saturday" },
    { beginning: "The flowers bloom", word: "в", translat: "in", ending: "April" },
    { beginning: "He was born", word: "у", translat: "in", ending: "1995" },
    { beginning: "We have a meeting", word: "о", translat: "at", ending: "9 o'clock" },
    { beginning: "The match is", word: "в", translat: "on", ending: "Friday" },
    { beginning: "School starts", word: "у", translat: "in", ending: "September" },
    { beginning: "The war ended", word: "у", translat: "in", ending: "1945" },
    { beginning: "Dinner is served", word: "о", translat: "at", ending: "6 o'clock" },
    { beginning: "The store is closed", word: "по", translat: "on", ending: "Mondays" },


    //lesson Прийменники місця
    { beginning: "The cat is", word: "на", translat: "on", ending: "the table" },
    { beginning: "The keys are", word: "під", translat: "under", ending: "the sofa" },
    { beginning: "The painting hangs", word: "над", translat: "above", ending: "the fireplace" },
    { beginning: "The shoes are", word: "біля", translat: "next to", ending: "the door" },
    { beginning: "The clock is", word: "перед", translat: "in front of", ending: "the window" },
    { beginning: "The dog is", word: "позаду", translat: "behind", ending: "the house" },
    { beginning: "The documents are", word: "в", translat: "in", ending: "the drawer" },
    { beginning: "The bench is", word: "між", translat: "between", ending: "two trees" },
    { beginning: "The book fell", word: "з", translat: "off", ending: "the shelf" },
    { beginning: "The picture is", word: "на", translat: "on", ending: "the wall" },

    //lesson Множина
    { beginning: "Many", word: "чоловіки", translat: "men", ending: "are working in the city" },
    { beginning: "Several", word: "жінки", translat: "women", ending: "are attending the conference" },
    { beginning: "The", word: "діти", translat: "children", ending: "are playing outside" },
    { beginning: "Our", word: "зуби", translat: "teeth", ending: "need to be cleaned regularly" },
    { beginning: "His", word: "ноги", translat: "feet", ending: "were sore after the race" },
    { beginning: "A group of", word: "миші", translat: "mice", ending: "are hiding in the attic" },
    { beginning: "The", word: "гуси", translat: "geese", ending: "are migrating south" },
    { beginning: "Several", word: "люди", translat: "people", ending: "were waiting in line" },
    { beginning: "The", word: "вівці", translat: "sheep", ending: "are grazing in the field" },
    { beginning: "Some", word: "риби", translat: "fish", ending: "are swimming in the pond" },

    //lesson Доконані часи
    { beginning: "The letters", word: "були надіслані", translat: "have been sent", ending: "by the office" },
    { beginning: "The house", word: "був побудований", translat: "was built", ending: "last year" },
    { beginning: "The cars", word: "ремонтувалися", translat: "were being repaired", ending: "all morning" },
    { beginning: "The reports", word: "були підготовлені", translat: "have been prepared", ending: "for the meeting" },
    { beginning: "The cake", word: "був спечений", translat: "was baked", ending: "yesterday" },
    { beginning: "The documents", word: "були перевірялися", translat: "were being checked", ending: "during the afternoon" },
    { beginning: "The emails", word: "були відправлені", translat: "have been sent", ending: "to the clients" },
    { beginning: "The window", word: "було розбите", translat: "was broken", ending: "by the storm" },
    { beginning: "The floors", word: "були миті", translat: "were being cleaned", ending: "all day" },
    { beginning: "The orders", word: "були виконані", translat: "have been completed", ending: "on time" },

*/
